import React from "react";

const CanIGetACreditActivityAlert = (props: any) => {
    return (
        <div>
            <p>
                Yes, the Child Credit Activity monitoring only informs you that activity occurred on your child's/dependent's TransUnion credit file. It does not
                provide information on whether there is a Protected Consumer Freeze (under 16) or a Freeze (16 & 17) already on the child's/dependent's credit
                report. This would be something you or the child/dependent would already know or could confirm after providing proof of guardianship to TransUnion.
            </p>
            <p>
                If there is a freeze on your child's/dependent's TransUnion credit file, you can have peace of mind that their credit is protected at TransUnion,
                but we also recommend that you contact the other Consumer Reporting Agencies as information can vary.
            </p>
            <p>
                Credit Activity information is still useful to you even if have a freeze placed on your child's/dependent's file because if an indicator of fraud,
                fraudsters could also be using your child's/dependent's SSN for other transactions that don't involve credit. And you are now informed and can take
                other precautions.
            </p>
        </div>
    );
};

export default CanIGetACreditActivityAlert;
